import styled from "styled-components";

export const StyledFooter = styled.footer`
  display: flex;
  flex-direction: row;
  flex: 0;
  justify-content: space-between;
  align-items: center;
  height: 7.2rem;
  min-height: 7.2rem;
  padding: 2.4rem;
  border-top: 0.1rem solid var(--neutral-neutral-80, #b5b5b5);

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    gap: 1.2rem;
    height: auto;
    min-height: auto;
    border-top: none;
    width: 100%;
    padding: 2.4rem 0 4rem;

    .ez-pay-menu-main {
      display: flex;
      justify-content: center;
      align-items: center;
      height: auto;
      width: 100%;
    }

    .ez-pay-menu-logo-helper {
      display: none;
    }

    .ez-pay-menu-logo {
      margin: 0;
      height: 3.2rem;
    }
  }
`;

export const StyledUlLinks = styled.ul`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin: 0;
  padding: 0;

  li {
    list-style: none;
  }

  @media only screen and (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 0.6rem;
    row-gap: 1rem;
    flex-wrap: wrap;

    li {
      display: flex;
      align-items: center;
    }

    .footer-copyright-text,
    .footer-all-rights-reserved-text {
      font-size: 10px;
      line-height: 1.4rem;
      color: var(--neutral-neutral-20, #3a3a3a);
      white-space: nowrap;
    }

    li:nth-child(1),
    li:nth-child(2),
    li:nth-child(3) {
      flex: 0 0 auto;
    }

    li:nth-child(5) {
      margin-right: calc(16px - 0.6rem);
    }

    li:nth-child(7) {
      margin-left: calc(16px - 0.6rem);
    }

    li:nth-child(4),
    li:nth-child(8) {
      flex-basis: 100%;
      justify-content: center;
    }

    li:nth-child(8) {
      margin-top: 0.4rem;
    }
  }
`;

export const StyledLiBorder = styled.li.attrs(() => ({
  "aria-hidden": true,
  role: "presentation",
}))`
  border: 0.1rem solid var(--primary-primary-50, #949494);
  height: 1.6rem;
  list-style: none;
`;

export const LinkBorder = styled.div`
  border: 0.1rem solid var(--primary-primary-50, #949494);
  height: 1.6rem;
`;
